import type { SVGProps } from 'react';
const SvgPlaylistAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M11.25 7.5H2.083v1.667h9.167zm0-3.333H2.083v1.666h9.167zm3.333 6.666V7.5h-1.666v3.333H9.583V12.5h3.334v3.333h1.666V12.5h3.334v-1.667zM2.083 12.5h5.834v-1.667H2.083z"
    />
  </svg>
);
export default SvgPlaylistAdd;
